/*
    Triggered Events

    data-form-submitted
    data-form-response-returned
    data-form-server-error-returned
    data-form-validation-errors-returned
    data-form-exception-returned
    data-form-success-returned

*/


define('flight-components/mixins/withForm',['require','flight/lib/compose','App','flight-components/mixins/withFormErrors'],function(require){

  // Dependencies
  var compose = require('flight/lib/compose');
  var App = require('App');
  
  return withForm;
  
  // Constructor
  function withForm() {

    compose.mixin(this, [
      require('flight-components/mixins/withFormErrors')
    ]);

    this.defaultAttrs({});


    this.handleFormSubmit = function(ev, data) {
      this.trigger('ui-form-submit-requested');
      ev.preventDefault();

      var self = this;
      var $form = $(data.el);
      var formData = this.parseNamedFields( $form );

      this.attr.action = $form.attr('action');
      this.attr.method = $form.attr('method');

      this.submitForm(formData);          
    
    };

    this.submitForm = function(data) {
      var self = this;
      var ajaxOpts = {
        method: self.attr.method,
        url: self.attr.action,
        data: data
      }

      var xhr = $.ajax(ajaxOpts);

      self.trigger('data-form-submitted', ajaxOpts);

      xhr.done(function(response){
        if (response.status == 'error') {
          // handle server-side validation errors
          if (response.content.validationItems.length > 0)
            self.handleServerValidationErrors(response.content.validationItems);
          if (response.content.exception != '')
            self.handleFormException(response.content.exception);                
        } else if (response.status == 'success') {
          self.handleFormSuccess(response);
        } else {
          // didn't recognize server response
        }
      });

      xhr.fail(function(error) {
        self.trigger('data-form-server-error-returned', {error: error});
      });

      xhr.always(function(response) {
        self.trigger('data-form-response-complete', {response: response});
      });

    };

    this.handleServerValidationErrors = function(errors) {
      this.trigger('data-form-validation-errors-returned', {errors: errors});
    };

    this.handleFormException = function(exception) {
      this.trigger('data-form-exception-returned', {exception: exception});
    };

    this.handleFormSuccess = function(response) {
      this.trigger('data-form-success-returned', {response: response})
    };

    this.formIsValid = function(formData) {
      return true;
    };

    this.parseNamedFields = function($el) {
      var data = {};
      $el.find('[name]').each(function() {
        var fieldValue;
        if ($(this).prop('type') === 'checkbox') {
          fieldValue = $(this).prop('checked') ? 1 : 0;
        } else {
          fieldValue = $(this).val();          
        }
        data[$(this).attr('name')] = fieldValue;
      });
      return data;
    };


    this.after('initialize', function() {

      this.on('submit', {
        'formSelector': this.handleFormSubmit
      });

    });

  };
});
